module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "sidebar",
    class: {
      'active': _vm.showSidebar
    }
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Stocks",
      "selected": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stockFilter),
      expression: "stockFilter"
    }],
    staticClass: "stock-search",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.stockFilter)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.goToFirstStock()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stockFilter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stock-list"
  }, [_vm._l((_vm.filteredStocks), function(stock) {
    return _c('list-item', {
      key: stock.symbol,
      attrs: {
        "active": stock.symbol == _vm.$route.params.symbol,
        "title": stock.symbol,
        "subtitle": stock.name,
        "starred": stock.starred
      },
      nativeOn: {
        "click": function($event) {
          _vm.goToStock(stock.symbol)
        }
      }
    })
  }), _vm._v(" "), (_vm.stockFilter !== '') ? _c('list-item', {
    attrs: {
      "title": 'Go to ' + _vm.stockFilter.toUpperCase()
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToStock(_vm.stockFilter)
      }
    }
  }) : _vm._e()], 2)]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Notes"
    }
  }, [_c('div', {
    staticClass: "stock-list"
  }, _vm._l((_vm.notes), function(note) {
    return _c('list-item', {
      key: note.name,
      attrs: {
        "active": note.name == _vm.$route.params.name,
        "title": note.title
      },
      nativeOn: {
        "click": function($event) {
          _vm.goToNote(note.name)
        }
      }
    })
  }))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "belly"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-bde5ff9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = 75
// module chunks = 0